import React, { Component } from "react";
import { Buffer } from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import Cookies from "universal-cookie";
import { Button, Modal, Table, message, Form, Row, Col, Space, Input, Select, Checkbox, Tooltip } from "antd";
import { dealerApiService } from "../../services/otodis/DealerApiService";
import { dealerService } from "../../services/otodisApi/DealerService";
import { EditOutlined, PlusCircleOutlined, DeleteOutlined, SaveOutlined, CloseCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { SettingDealerStates } from "./types/SettingDealerTypes";
import withAuth from "../../hoc/withAuth";
import AreaProvinceSelect from "../../components/area/AreaProvinceSelect";
import AreaCitySelect from "../../components/area/AreaCitySelect";
import AreaDistrictSelect from "../../components/area/AreaDistrictSelect";
import AreaSubdistrictSelect from "../../components/area/AreaSubdistrictSelect";

export interface HomeProps {}

class SettingDealer extends Component<HomeProps & any, SettingDealerStates> {
  private readonly initState!: SettingDealerStates;
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
  private token = new Cookies().get("_t");
  private listIamDealer = JSON.parse(Buffer.from(new Cookies().get("_d"), "base64").toString());
  private tableColumn: any = [
    {
      title: "Kode Dealer",
      dataIndex: "dealer_code",
      width: 80,
    },
    {
      title: "Nama Dealer",
      dataIndex: "dealer_name",
      width: 150,
    },
    {
      title: "Kode Perusahaan",
      dataIndex: "company_code",
      width: 150,
    },
    {
      title: "Area",
      dataIndex: "city_group",
      width: 150,
    },
    {
      title: "Stop Closing",
      dataIndex: "set_stop_closing",
      width: 80,
      render: (value: boolean, row: any) => {
        return <span className={`font-90`}>{value?.toString()?.toUpperCase()}</span>;
      },
    },
    {
      title: "Allow Edit Stock",
      dataIndex: "allow_edit_stock",
      width: 80,
      render: (value: boolean, row: any) => {
        return <span className={`font-90`}>{value?.toString()?.toUpperCase()}</span>;
      },
    },
    {
      title: "Allow Empty Engine Number",
      dataIndex: "allow_empty_engine_number",
      width: 80,
      render: (value: boolean, row: any) => {
        return <span className={`font-90`}>{value?.toString()?.toUpperCase()}</span>;
      },
    },
    {
      title: "Persentasi Pajak",
      dataIndex: "setting_tax_percentage",
      width: 80,
      render: (value: boolean, row: any) => {
        return <span className={`font-90`}>{value} %</span>;
      },
    },
    {
      title: "Status",
      dataIndex: "active",
      width: 80,
      render: (value: boolean) => {
        return <span className={`font-90`}>{value === true ? "ACTIVE" : "NONACTIVE"}</span>;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 100,
      render: (value: string, row: []) => {
        return (
          <React.Fragment>
            <Button size={"small"} type={"primary"} onClick={(event) => this.onClickEditDealer(row)}>
              {" "}
              <EditOutlined /> Edit
            </Button>
          </React.Fragment>
        );
      },
    },
  ];

  constructor(props: (HomeProps & any) | any) {
    super(props);

    this.initState = {
      processing: false,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),

      showTableDealer: true,
      dataDealer: [],
      processingFetchTableData: true,
      pageSize: 100,

      showFormDealer: false,
      modeForm: "ADD",
      selectedDealer: {},
      isEditAddionalDataChecked: false,

      inputDealerCode: "",
      inputDealerName: "",
      selectCompanyCode: "",
      selectCityGroup: "",
      inputBcaCompanyCode: "",
      inputBcaCompanyAccount: "",
      inputTaxAccountNumber: "",
      inputTaxAccountName: "",

      selectStatusDealer: "true",
      selectCreateWarehouseDefault: "true",
      selectCreateSupplierDefault: "true",
      selectSetStopClosing: "false",
      selectAllowEditStock: "false",
      selectAllowEmptyEngineNumber: "false",
      selectAllowSentOrderToAmh: "false",
      selectAllowTrackOrder: "false",
      selectAllowCreateBillLeasing: "false",

      inputEmail: "",
      inputPhone: "",
      inputTelegramChannel: "",

      inputAddress: "",
      inputLinkMap: "",
      inputProvinceCode: "",
      inputProvinceName: "",
      inputCityCode: "",
      inputCityName: "",
      inputDistrictCode: "",
      inputDistrictName: "",
      inputSubDistrictCode: "",
      inputSubDistrictName: "",
      inputPostalCode: "",

      inputTargetBussinessIdIn: "",
      inputTargetBussinessNameIn: "",
      inputTargetBussinessIdOut: "",
      inputTargetBussinessNameOut: "",

      inputTargetProcessId: "",
      inputTargetProcessName: "",
      inputTargetPkbId: "",
      inputTargetPkbName: "",
      inputTargetServiceId: "",
      inputTargetServiceName: "",

      inputMainDealerCode: "",
      inputMainDealerCustomerCode: "",
      inputMainDealerPassAuth: "",
      inputMainDealerUserAuth: "",

      inpustWhatsappProjectID: "",

      modalAddWhatappsTemplate: false,
      objWhatappsTemplate: [],
      inputWhatappsTemplateName: "",
      inputWhatappsTriggerId: "",
      inputWhatappsTemplateStatus: "BAST",
      inputTaxPercentage: 0,
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      processingFetchTableData: true,
      dealerCode: data.value,
    });

    await this.fetchDealerData();
  };

  fetchDealerData = async () => {
    await this.promisedSetState({
      processingFetchTableData: true,
    });

    await dealerApiService
      .getDealer({
        // dealerCode: this.state.dealerCode
      })
      .then(async (value) => {
        const showDealer = value.data.data;
        // for (const element of value.data.data) {
        //   // const picked = this.listIamDealer.find((o: { DealerCode: string }) => o.DealerCode === element.dealer_code);
        //   // if (picked) {
        //   showDealer.push(element);
        //   // }
        // }

        await this.promisedSetState({
          dataDealer: showDealer,
          processingFetchTableData: false,
        });
      })
      .catch(async (reason) => {
        await this.promisedSetState({
          dataDealer: [],
          processingFetchTableData: false,
        });
        message.error("Data Tidak Ditemukan");
      });
  };

  onChangeTable = (pagination: any, filters: any, sorter: any) => {
    console.log(pagination);
    console.log(filters);
    console.log(sorter);
    if (pagination?.pageSize) {
      this.setState({
        pageSize: pagination?.pageSize,
      });
    }
  };

  onResetForm = () => {
    this.setState({
      processing: false,
      modeForm: "ADD",
      isEditAddionalDataChecked: false,
      selectedDealer: {},

      inputDealerCode: "",
      inputDealerName: "",
      selectCompanyCode: "",
      selectCityGroup: "",
      inputBcaCompanyCode: "",
      inputBcaCompanyAccount: "",
      inputTaxAccountNumber: "",
      inputTaxAccountName: "",

      selectStatusDealer: "true",
      selectCreateWarehouseDefault: "true",
      selectCreateSupplierDefault: "true",
      selectSetStopClosing: "false",
      selectAllowEditStock: "false",
      selectAllowEmptyEngineNumber: "false",
      selectAllowSentOrderToAmh: "false",
      selectAllowTrackOrder: "false",
      selectAllowCreateBillLeasing: "false",

      inputEmail: "",
      inputPhone: "",
      inputTelegramChannel: "",

      inputAddress: "",
      inputLinkMap: "",
      inputProvinceCode: "",
      inputProvinceName: "",
      inputCityCode: "",
      inputCityName: "",
      inputDistrictCode: "",
      inputDistrictName: "",
      inputSubDistrictCode: "",
      inputSubDistrictName: "",
      inputPostalCode: "",

      inputTargetBussinessIdIn: "",
      inputTargetBussinessNameIn: "",
      inputTargetBussinessIdOut: "",
      inputTargetBussinessNameOut: "",

      inputTargetProcessId: "",
      inputTargetProcessName: "",
      inputTargetPkbId: "",
      inputTargetPkbName: "",
      inputTargetServiceId: "",
      inputTargetServiceName: "",

      inputMainDealerCode: "",
      inputMainDealerCustomerCode: "",
      inputMainDealerPassAuth: "",
      inputMainDealerUserAuth: "",

      inpustWhatsappProjectID: "",

      modalAddWhatappsTemplate: false,
      objWhatappsTemplate: [],
      inputWhatappsTemplateName: "",
      inputWhatappsTriggerId: "",
      inputWhatappsTemplateStatus: "BAST",
      inputTaxPercentage: 0,
    });
  };

  onClickAddDealer = async () => {
    this.setState({
      showTableDealer: false,
      showFormDealer: true,
    });

    this.onResetForm();
  };

  onClickEditDealer = async (data: any) => {
    this.setState({
      showTableDealer: false,
      showFormDealer: true,
      modeForm: "EDIT",
      selectedDealer: data,
      isEditAddionalDataChecked: false,

      inputDealerCode: data.dealer_code,
      inputDealerName: data.dealer_name,
      selectCompanyCode: data.company_code,
      selectCityGroup: data.city_group,
      inputBcaCompanyCode: data.bca_company_code,
      inputBcaCompanyAccount: data.bca_company_account,
      inputTaxAccountNumber: data.vat_account_number,
      inputTaxAccountName: data.vat_account_name,

      selectStatusDealer: data.active?.toString()?.toLowerCase(),
      selectCreateWarehouseDefault: "false",
      selectCreateSupplierDefault: "false",
      selectSetStopClosing: data.set_stop_closing?.toString()?.toLowerCase(),
      selectAllowSentOrderToAmh: data.allow_sent_order_to_amh?.toString()?.toLowerCase() || "false",
      selectAllowTrackOrder: data.allow_track_order?.toString()?.toLowerCase() || "false",
      selectAllowCreateBillLeasing: data.allow_create_bill_leasing?.toString()?.toLowerCase() || "false",
      selectAllowEditStock: data.allow_edit_stock?.toString()?.toLowerCase() || "false",
      selectAllowEmptyEngineNumber: data.allow_empty_engine_number?.toString()?.toLowerCase() || "false",

      inputEmail: data.email || "",
      inputPhone: data.phone || "",
      inputTelegramChannel: data.telegram_channel || "",

      inputAddress: data.address,
      inputLinkMap: data?.additional_data?.gmap_dealer,
      inputProvinceCode: data.province_code,
      inputProvinceName: data.province_name,
      inputCityCode: data.city_code,
      inputCityName: data.city_name,
      inputDistrictCode: data.district_code,
      inputDistrictName: data.district_name,
      inputSubDistrictCode: data.sub_district_code,
      inputSubDistrictName: data.sub_district_name,
      inputPostalCode: data.postal_code,

      inputTargetBussinessIdIn: data?.robobill?.in_organization_target_business_id || "",
      inputTargetBussinessNameIn: data?.robobill?.in_organization_target_name || "",
      inputTargetBussinessIdOut: data?.robobill?.out_organization_target_business_id || "",
      inputTargetBussinessNameOut: data?.robobill?.out_organization_target_name || "",

      inputTargetProcessId: data?.setting_bill_bbn?.bill_process_cost?.id || "",
      inputTargetProcessName: data?.setting_bill_bbn?.bill_process_cost?.name || "",
      inputTargetPkbId: data?.setting_bill_bbn?.bill_pkb?.id || "",
      inputTargetPkbName: data?.setting_bill_bbn?.bill_pkb?.name || "",
      inputTargetServiceId: data?.setting_bill_bbn?.bill_service_cost?.id || "",
      inputTargetServiceName: data?.setting_bill_bbn?.bill_service_cost?.name || "",

      inputMainDealerCode: data.main_dealer_code || "",
      inputMainDealerCustomerCode: data.main_dealer_customer_code || "",
      inputMainDealerUserAuth: data.main_dealer_user_auth || "",
      inputMainDealerPassAuth: "",

      inpustWhatsappProjectID: data?.option_whatapps?.project_id || "",

      objWhatappsTemplate: data?.option_whatapps?.data ? data?.option_whatapps?.data : [],
      inputWhatappsTemplateName: "",
      inputWhatappsTriggerId: "",
      inputWhatappsTemplateStatus: "BAST",
      inputTaxPercentage: data.setting_tax_percentage,
    });
  };

  onClicksave = async () => {
    const currentState = this.state;
    const textError = this.validateDataInput(currentState);

    if (textError !== "") {
      Modal.error({
        title: "Error Validasi",
        content: textError.split("\n").map((line, index) => (
          <>
            {line}
            <br />
          </>
        )), // Format konten dengan enter
      });

      return false;
    }
    await this.setState({ processing: true });

    if (currentState.modeForm === "ADD") {
      let newDealer = {
        dealer_code: currentState.inputDealerCode,
        dealer_name: currentState.inputDealerName,
        company_code: currentState.selectCompanyCode,
        city_group: currentState.selectCityGroup,
        bca_company_code: currentState.inputBcaCompanyCode,
        bca_company_account: currentState.inputBcaCompanyAccount,
        vat_account_number: currentState.inputTaxAccountNumber,
        vat_account_name: currentState.inputTaxAccountName,
        setting_tax_percentage: currentState.inputTaxPercentage,

        active: currentState.selectStatusDealer === "true" ? true : false,
        create_default_warehouse: currentState.selectCreateWarehouseDefault === "true" ? true : false,
        create_default_supplier: currentState.selectCreateSupplierDefault === "true" ? true : false,
        set_stop_closing: currentState.selectSetStopClosing === "true" ? true : false,
        allow_edit_stock: currentState.selectAllowEditStock === "true" ? true : false,
        allow_empty_engine_number: currentState.selectAllowEmptyEngineNumber === "true" ? true : false,
        allow_sent_order_to_amh: currentState.selectAllowSentOrderToAmh === "true" ? true : false,
        allow_track_order: currentState.selectAllowTrackOrder === "true" ? true : false,
        allow_create_bill_leasing: currentState.selectAllowCreateBillLeasing === "true" ? true : false,

        address: currentState.inputAddress,
        province_code: currentState.inputProvinceCode,
        province_name: currentState.inputProvinceName,
        city_code: currentState.inputCityCode,
        city_name: currentState.inputCityName,
        district_code: currentState.inputDistrictCode,
        district_name: currentState.inputDistrictName,
        sub_district_code: currentState.inputSubDistrictCode,
        sub_district_name: currentState.inputSubDistrictName,
        postal_code: currentState.inputPostalCode,

        phone: currentState.inputPhone,
        email: currentState.inputEmail,
        telegram_channel: currentState.inputTelegramChannel,

        main_dealer_code: currentState.inputMainDealerCode,
        main_dealer_customer_code: currentState.inputMainDealerCustomerCode,
        main_dealer_user_auth: currentState.inputMainDealerUserAuth,
        main_dealer_pass_auth: currentState.inputMainDealerPassAuth,

        additional_data: {
          alias_dealer: currentState.inputDealerName,
          address_dealer: currentState.inputAddress,
          gmap_dealer: currentState.inputLinkMap,
        },

        robobill: {
          in_organization_target_business_id: currentState.inputTargetBussinessIdIn,
          in_organization_target_name: currentState.inputTargetBussinessNameIn,
          out_organization_target_business_id: currentState.inputTargetBussinessIdOut,
          out_organization_target_name: currentState.inputTargetBussinessNameOut,
        },

        setting_bill_bbn: {
          bill_process_cost: {
            name: currentState.inputTargetProcessId,
            id: currentState.inputTargetProcessName,
          },
          bill_pkb: {
            name: currentState.inputTargetPkbId,
            id: currentState.inputTargetPkbName,
          },
          bill_service_cost: {
            name: currentState.inputTargetServiceId,
            id: currentState.inputTargetServiceName,
          },
        },

        option_whatapps: { project_id: currentState.inpustWhatsappProjectID, data: currentState.objWhatappsTemplate },
      };

      console.log("Service Name", currentState.inputTargetServiceName);

      dealerService.setToken(this.token);
      await dealerService
        .addDealer(newDealer)
        .then((result) => {
          Modal.success({
            title: "Proses Sukses",
            content: "Dealer berhasil di tambahkan",
          });

          this.onCloseFormWindow();
        })
        .catch((e: any) => {
          Modal.error({
            title: "Proses Gagal",
            content: e.message,
          });
          this.setState({ processing: false });
        });
    } else if (currentState.modeForm === "EDIT") {
      const oldDataDealer = currentState.selectedDealer;
      let newDataDealer: any = {
        dealer_code: currentState.inputDealerCode,
        active: currentState.selectStatusDealer === "true" ? true : false,

        updated_by: this.user,
      };

      if (oldDataDealer.dealer_name !== currentState.inputDealerName) {
        newDataDealer["dealer_name"] = currentState.inputDealerName;
      }

      if (oldDataDealer.bca_company_code !== currentState.inputBcaCompanyCode) {
        newDataDealer["bca_company_code"] = currentState.inputBcaCompanyCode;
      }
      if (oldDataDealer.bca_company_account !== currentState.inputBcaCompanyAccount) {
        newDataDealer["bca_company_account"] = currentState.inputBcaCompanyAccount;
      }
      if (oldDataDealer.vat_account_name !== currentState.inputTaxAccountName) {
        newDataDealer["vat_account_name"] = currentState.inputTaxAccountName;
      }
      if (oldDataDealer.vat_account_number !== currentState.inputTaxAccountNumber) {
        newDataDealer["vat_account_number"] = currentState.inputTaxAccountNumber;
      }
      if (oldDataDealer.setting_tax_percentage !== currentState.inputTaxPercentage) {
        newDataDealer["setting_tax_percentage"] = currentState.inputTaxPercentage;
      }

      const stopClosing = currentState.selectSetStopClosing === "true" ? true : false;
      if (oldDataDealer.set_stop_closing !== stopClosing) {
        newDataDealer["set_stop_closing"] = stopClosing;
      }
      const allowSentOrderToAmh = currentState.selectAllowSentOrderToAmh === "true" ? true : false;
      if (oldDataDealer.allow_sent_order_to_amh !== allowSentOrderToAmh) {
        newDataDealer["allow_sent_order_to_amh"] = allowSentOrderToAmh;
      }
      const allowTrackOrder = currentState.selectAllowTrackOrder === "true" ? true : false;
      if (oldDataDealer.allow_track_order !== allowTrackOrder) {
        newDataDealer["allow_track_order"] = allowTrackOrder;
      }
      const allowCreateBillLeasing = currentState.selectAllowCreateBillLeasing === "true" ? true : false;
      if (oldDataDealer.allow_create_bill_leasing !== allowCreateBillLeasing) {
        newDataDealer["allow_create_bill_leasing"] = allowCreateBillLeasing;
      }
      const allowEditStock = currentState.selectAllowEditStock === "true" ? true : false;
      if (oldDataDealer.allow_edit_stock !== allowEditStock) {
        newDataDealer["allow_edit_stock"] = allowEditStock;
      }

      const allowEmptyEngineNumber = currentState.selectAllowEmptyEngineNumber === "true" ? true : false;
      if (oldDataDealer.allow_empty_engine_number !== allowEmptyEngineNumber) {
        newDataDealer["allow_empty_engine_number"] = allowEmptyEngineNumber;
      }

      const additional_data = {
        address_dealer: oldDataDealer?.additional_data?.address_dealer,
        alias_dealer: oldDataDealer?.additional_data?.alias_dealer,
        gmap_dealer: currentState.inputLinkMap,
      };

      if (JSON.stringify(oldDataDealer?.additional_data) !== JSON.stringify(additional_data)) {
        newDataDealer["additional_data"] = additional_data;
      }

      const option_whatapps = { project_id: currentState.inpustWhatsappProjectID, data: currentState.objWhatappsTemplate };
      if (oldDataDealer?.option_whatapps !== option_whatapps) {
        newDataDealer["option_whatapps"] = option_whatapps;
      }

      if (oldDataDealer.address !== currentState.inputAddress) {
        newDataDealer["address"] = currentState.inputAddress;
      }
      if (oldDataDealer.province_code !== currentState.inputProvinceCode) {
        newDataDealer["province_code"] = currentState.inputProvinceCode;
      }
      if (oldDataDealer.province_name !== currentState.inputProvinceName) {
        newDataDealer["province_name"] = currentState.inputProvinceName;
      }
      if (oldDataDealer.city_code !== currentState.inputCityCode) {
        newDataDealer["city_code"] = currentState.inputCityCode;
      }
      if (oldDataDealer.city_name !== currentState.inputCityName) {
        newDataDealer["city_name"] = currentState.inputCityName;
      }
      if (oldDataDealer.district_code !== currentState.inputDistrictCode) {
        newDataDealer["district_code"] = currentState.inputDistrictCode;
      }
      if (oldDataDealer.district_name !== currentState.inputDistrictName) {
        newDataDealer["district_name"] = currentState.inputDistrictName;
      }
      if (oldDataDealer.sub_district_code !== currentState.inputSubDistrictCode) {
        newDataDealer["sub_district_code"] = currentState.inputSubDistrictCode;
      }
      if (oldDataDealer.sub_district_name !== currentState.inputSubDistrictName) {
        newDataDealer["sub_district_name"] = currentState.inputSubDistrictName;
      }
      if (oldDataDealer.postal_code !== currentState.inputPostalCode) {
        newDataDealer["postal_code"] = currentState.inputPostalCode;
      }
      if (oldDataDealer.phone !== currentState.inputPhone) {
        newDataDealer["phone"] = currentState.inputPhone;
      }
      if (oldDataDealer.email !== currentState.inputEmail) {
        newDataDealer["email"] = currentState.inputEmail;
      }
      if (oldDataDealer.telegram_channel !== currentState.inputTelegramChannel) {
        newDataDealer["telegram_channel"] = currentState.inputTelegramChannel;
      }

      if (currentState.isEditAddionalDataChecked) {
        newDataDealer["robobill"] = {
          in_organization_target_business_id: currentState.inputTargetBussinessIdIn,
          in_organization_target_name: currentState.inputTargetBussinessNameIn,
          out_organization_target_business_id: currentState.inputTargetBussinessIdOut,
          out_organization_target_name: currentState.inputTargetBussinessNameOut,
        };

        newDataDealer["main_dealer_code"] = currentState.inputMainDealerCode;
        newDataDealer["main_dealer_customer_code"] = currentState.inputMainDealerCustomerCode;
        newDataDealer["main_dealer_user_auth"] = currentState.inputMainDealerUserAuth;
        newDataDealer["main_dealer_pass_auth"] = currentState.inputMainDealerPassAuth;

        newDataDealer["setting_bill_bbn"] = {
          bill_process_cost: {
            id: currentState.inputTargetProcessId,
            name: currentState.inputTargetProcessName,
          },
          bill_pkb: {
            id: currentState.inputTargetPkbId,
            name: currentState.inputTargetPkbName,
          },
          bill_service_cost: {
            id: currentState.inputTargetServiceId,
            name: currentState.inputTargetServiceName,
          },
        };
      }

      dealerService.setToken(this.token);
      await dealerService
        .updateDealer(newDataDealer)
        .then((result: any) => {
          Modal.success({
            title: "Proses Sukses",
            content: "Dealer berhasil di update",
          });

          this.onCloseFormWindow();
        })
        .catch((e: any) => {
          Modal.error({
            title: "Proses Gagal",
            content: e.message,
          });
          this.setState({ processing: false });
        });
    }

    console.log("Process Id", currentState.inputTargetProcessId);
    console.log("Process Name", currentState.inputTargetProcessName);
    console.log("PKB Id", currentState.inputTargetPkbId);
    console.log("PKB Name", currentState.inputTargetPkbName);
    console.log("Service Id", currentState.inputTargetServiceId);

    await this.fetchDealerData();
  };

  validateDataInput = (currentState: Readonly<SettingDealerStates>) => {
    let textError = "";
    if (!currentState.inputDealerCode) {
      textError += `Kode Dealer  is Required \n`;
    }
    if (!currentState.inputDealerName) {
      textError += `Nama Dealer  is Required \n`;
    }
    if (!currentState.selectCompanyCode) {
      textError += `Kode Perusahaan is Required \n`;
    }
    if (!currentState.selectCityGroup) {
      textError += `Area Dealer is Required \n`;
    }
    if (!currentState.inputBcaCompanyCode) {
      textError += `Kode Rekening is Required \n`;
    }
    if (!currentState.inputBcaCompanyAccount) {
      textError += `Nomor Rekening is Required \n`;
    }
    if (!currentState.inputTaxAccountNumber) {
      textError += `Nomor NPWP is Required \n`;
    }
    if (!currentState.inputTaxAccountName) {
      textError += `Nama NPWP is Required \n`;
    }
    if (!currentState.selectStatusDealer) {
      textError += `Status Dealer is Required\n`;
    }
    if (!currentState.selectCreateWarehouseDefault) {
      textError += `Otomatis Buat Gudang is Required\n`;
    }
    if (!currentState.selectCreateSupplierDefault) {
      textError += `Otomatis Buat Supplier is Required\n`;
    }
    if (!currentState.selectSetStopClosing) {
      textError += `Stop Closing is Required\n`;
    }
    if (!currentState.selectAllowSentOrderToAmh) {
      textError += `Buat Tagihan Leasing is Required\n`;
    }
    if (!currentState.selectAllowTrackOrder) {
      textError += `Order BAST to AMH is Required\n`;
    }
    if (!currentState.selectAllowCreateBillLeasing) {
      textError += `Order BAST Tracking is Required\n`;
    }
    if (!currentState.selectAllowEditStock) {
      textError += `Allow Edit Stock is Required\n`;
    }
    if (!currentState.selectAllowEmptyEngineNumber) {
      textError += `Allow Empty Engine Number is Required\n`;
    }

    return textError;
  };

  onCloseFormWindow = async () => {
    this.setState({
      showTableDealer: true,
      showFormDealer: false,
    });

    this.onResetForm();
  };

  onAreaProvinceChange = (data: any) => {
    this.setState({
      inputProvinceCode: data.value,
      inputProvinceName: data.children,
      inputCityCode: "",
      inputCityName: "",
      inputDistrictCode: "",
      inputDistrictName: "",
      inputSubDistrictCode: "",
      inputSubDistrictName: "",
    });
  };

  onAreaCityChange = (data: any) => {
    this.setState({
      inputCityCode: data.value,
      inputCityName: data.children,
      inputDistrictCode: "",
      inputDistrictName: "",
      inputSubDistrictCode: "",
      inputSubDistrictName: "",
    });
  };

  onAreaDistrictChange = (data: any) => {
    this.setState({
      inputDistrictCode: data.value,
      inputDistrictName: data.children,
      inputSubDistrictCode: "",
      inputSubDistrictName: "",
    });
  };

  onAreaSubdistrictChange = (data: any) => {
    this.setState({
      inputSubDistrictCode: data.value,
      inputSubDistrictName: data.children,
      inputPostalCode: data.postalCode,
    });
  };

  showModalWhatappsTemplate = async () => {
    this.setState({
      modalAddWhatappsTemplate: true,
      inputWhatappsTemplateName: "",
      inputWhatappsTriggerId: "",
      inputWhatappsTemplateStatus: "",
    });
  };

  closeModalAddWhatappsTemplate = async () => {
    this.setState({
      modalAddWhatappsTemplate: false,
      inputWhatappsTemplateName: "",
      inputWhatappsTriggerId: "",
      inputWhatappsTemplateStatus: "",
    });
  };

  addWhatappsTemplate = async () => {
    const template_name = this.state.inputWhatappsTemplateName;
    const template_trigger_id = this.state.inputWhatappsTriggerId;
    const template_status = this.state.inputWhatappsTemplateStatus;
    if (template_name !== "" && template_trigger_id !== "" && template_status !== "") {
      const objWhatappsTemplate = this.state.objWhatappsTemplate;
      const new_color = {
        template_name,
        template_trigger_id,
        template_status,
      };

      objWhatappsTemplate.push(new_color);
      this.setState({
        modalAddWhatappsTemplate: false,
        objWhatappsTemplate: objWhatappsTemplate,
      });
    } else {
      Modal.error({
        title: "Error Validation",
        content: "Error Validation",
      });
    }
  };

  deleteWhatappsTemplate = (value: any) => {
    let objWhatappsTemplate = this.state.objWhatappsTemplate;
    const index = objWhatappsTemplate.indexOf(value);
    if (index !== -1) {
      objWhatappsTemplate.splice(index, 1);
    }
    this.setState({
      objWhatappsTemplate: objWhatappsTemplate,
    });
  };

  onFieldChange = async <
    T extends keyof Pick<
      any,
      | "inputDealerCode"
      | "inputDealerName"
      | "selectCompanyCode"
      | "selectCityGroup"
      | "inputBcaCompanyCode"
      | "inputBcaCompanyAccount"
      | "inputTaxAccountNumber"
      | "inputTaxAccountName"
      | "inputTaxPercentage"
      | "selectCreateWarehouseDefault"
      | "selectCreateSupplierDefault"
      | "selectStatusDealer"
      | "selectSetStopClosing"
      | "selectAllowSentOrderToAmh"
      | "selectAllowTrackOrder"
      | "selectAllowCreateBillLeasing"
      | "selectAllowEditStock"
      | "selectAllowEmptyEngineNumber"
      | "inputEmail"
      | "inputPhone"
      | "inputTelegramChannel"
      | "inputAddress"
      | "inputPostalCode"
      | "inputLinkMap"
      | "inputMainDealerCode"
      | "inputMainDealerCustomerCode"
      | "inputMainDealerPassAuth"
      | "inputMainDealerUserAuth"
      | "inputTargetBussinessIdIn"
      | "inputTargetBussinessNameIn"
      | "inputTargetBussinessIdOut"
      | "inputTargetBussinessNameOut"
      | "inpustWhatsappProjectID"
      | "inputWhatappsTemplateName"
      | "inputWhatappsTriggerId"
      | "inputWhatappsTemplateStatus"
      | "inputTargetProcessId"
      | "inputTargetProcessName"
      | "inputTargetPkbId"
      | "inputTargetPkbName"
      | "inputTargetServiceId"
      | "inputTargetServiceName"
    >
  >(
    target: T,
    value: any
  ) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "inputDealerCode":
        currentState.inputDealerCode = value;
        break;
      case "inputDealerName":
        currentState.inputDealerName = value;
        break;
      case "selectCompanyCode":
        currentState.selectCompanyCode = value;
        break;
      case "selectCityGroup":
        currentState.selectCityGroup = value;
        break;
      case "inputBcaCompanyCode":
        currentState.inputBcaCompanyCode = value;
        break;
      case "inputBcaCompanyAccount":
        currentState.inputBcaCompanyAccount = value;
        break;
      case "inputTaxAccountNumber":
        currentState.inputTaxAccountNumber = value;
        break;
      case "inputTaxAccountName":
        currentState.inputTaxAccountName = value;
        break;
      case "inputTaxPercentage":
        currentState.inputTaxPercentage = value;
        break;
      case "selectStatusDealer":
        currentState.selectStatusDealer = value;
        break;
      case "selectCreateWarehouseDefault":
        currentState.selectCreateWarehouseDefault = value;
        break;
      case "selectCreateSupplierDefault":
        currentState.selectCreateSupplierDefault = value;
        break;
      case "selectSetStopClosing":
        currentState.selectSetStopClosing = value;
        break;
      case "selectAllowEditStock":
        currentState.selectAllowEditStock = value;
        break;
      case "selectAllowEmptyEngineNumber":
        currentState.selectAllowEmptyEngineNumber = value;
        break;
      case "selectAllowSentOrderToAmh":
        currentState.selectAllowSentOrderToAmh = value;
        break;
      case "selectAllowTrackOrder":
        currentState.selectAllowTrackOrder = value;
        break;
      case "selectAllowCreateBillLeasing":
        currentState.selectAllowCreateBillLeasing = value;
        break;
      case "inputEmail":
        currentState.inputEmail = value;
        break;
      case "inputPhone":
        currentState.inputPhone = value;
        break;
      case "inputTelegramChannel":
        currentState.inputTelegramChannel = value;
        break;
      case "inputAddress":
        currentState.inputAddress = value;
        break;
      case "inputPostalCode":
        currentState.inputPostalCode = value;
        break;
      case "inputLinkMap":
        currentState.inputLinkMap = value;
        break;
      case "inputTargetBussinessIdIn":
        currentState.inputTargetBussinessIdIn = value;
        break;
      case "inputTargetBussinessNameIn":
        currentState.inputTargetBussinessNameIn = value;
        break;
      case "inputTargetBussinessIdOut":
        currentState.inputTargetBussinessIdOut = value;
        break;
      case "inputTargetBussinessNameOut":
        currentState.inputTargetBussinessNameOut = value;
        break;
      case "inputMainDealerCode":
        currentState.inputMainDealerCode = value;
        break;
      case "inputMainDealerCustomerCode":
        currentState.inputMainDealerCustomerCode = value;
        break;
      case "inputMainDealerPassAuth":
        currentState.inputMainDealerPassAuth = value;
        break;
      case "inputMainDealerUserAuth":
        currentState.inputMainDealerUserAuth = value;
        break;
      case "inpustWhatsappProjectID":
        currentState.inpustWhatsappProjectID = value;
        break;
      case "inputWhatappsTemplateName":
        currentState.inputWhatappsTemplateName = value;
        break;
      case "inputWhatappsTriggerId":
        currentState.inputWhatappsTriggerId = value;
        break;
      case "inputWhatappsTemplateStatus":
        currentState.inputWhatappsTemplateStatus = value;
        break;
      case "inputTargetProcessId":
        currentState.inputTargetProcessId = value;
        break;
      case "inputTargetProcessName":
        currentState.inputTargetProcessName = value;
        break;
      case "inputTargetPkbId":
        currentState.inputTargetPkbId = value;
        break;
      case "inputTargetPkbName":
        currentState.inputTargetPkbName = value;
        break;
      case "inputTargetServiceId":
        currentState.inputTargetServiceId = value;
        break;
      case "inputTargetServiceName":
        currentState.inputTargetServiceName = value;
        break;
    }
    await this.promisedSetState({
      ...currentState,
    });
  };

  async componentDidMount() {
    await this.fetchDealerData();
  }

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          noPadNoMar={true}
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Setting`}
          breadcrumbMenu={`Setting Dealer`}
          defaultSelectedKeys={["m-setting-dealer"]}
          defaultOpenKeys={["sm-setting"]}
        >
          {this.state.showTableDealer && (
            <div>
              <div style={{ padding: 20 }}>
                <Button
                  type="primary"
                  icon={<PlusCircleOutlined />}
                  onClick={() => {
                    this.onClickAddDealer();
                  }}
                >
                  {" "}
                  Tambah
                </Button>
              </div>
              <Table
                rowKey={"dealer_code"}
                size={"small"}
                scroll={{ x: "calc(500px + 50%)" }}
                loading={this.state.processingFetchTableData}
                columns={this.tableColumn}
                dataSource={this.state.dataDealer}
                pagination={{ pageSize: this.state.pageSize }}
                onChange={this.onChangeTable}
              />
            </div>
          )}

          {this.state.showFormDealer && (
            <div style={{ padding: 20 }}>
              <Form layout={"vertical"}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Kode Dealer <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.inputDealerCode} onChange={(event) => this.onFieldChange("inputDealerCode", event.target.value)} disabled={this.state.modeForm === "EDIT"} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Nama Dealer <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.inputDealerName} onChange={(event) => this.onFieldChange("inputDealerName", event.target.value)} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Kode Perusahaan <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.selectCompanyCode} onChange={(event) => this.onFieldChange("selectCompanyCode", event.target.value)} disabled={this.state.modeForm === "EDIT"} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Area Dealer <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.selectCityGroup} onChange={(event) => this.onFieldChange("selectCityGroup", event.target.value)} disabled={this.state.modeForm === "EDIT"} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Phone</i>
                          <Input value={this.state.inputPhone} onChange={(event) => this.onFieldChange("inputPhone", event.target.value)} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Email</i>
                          <Input value={this.state.inputEmail} onChange={(event) => this.onFieldChange("inputEmail", event.target.value)} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Provinsi</i>
                          <AreaProvinceSelect
                            onAreaProvinceChangeProps={this.onAreaProvinceChange}
                            country={"idn"}
                            provinceCode={this.state.inputProvinceCode}
                            provinceName={this.state.inputProvinceName}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Kota/Kab</i>
                          <AreaCitySelect onAreaCityChangeProps={this.onAreaCityChange} provinceCode={this.state.inputProvinceCode} cityName={this.state.inputCityName} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Kecamatan</i>
                          <AreaDistrictSelect onAreaDistrictChangeProps={this.onAreaDistrictChange} cityCode={this.state.inputCityCode} districtName={this.state.inputDistrictName} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Kelurahan</i>
                          <AreaSubdistrictSelect
                            onAreaSubdistrictChangeProps={this.onAreaSubdistrictChange}
                            districtCode={this.state.inputDistrictCode}
                            subdistrictName={this.state.inputSubDistrictName}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Kode POS</i>
                          <Input value={this.state.inputPostalCode} onChange={(event) => this.onFieldChange("inputPostalCode", event.target.value)} />
                        </Form.Item>
                      </Col>

                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Link Google Map</i>
                          <Input value={this.state.inputLinkMap} onChange={(event) => this.onFieldChange("inputLinkMap", event.target.value)} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Telegram Channel</i>
                          <Input value={this.state.inputTelegramChannel} onChange={(event) => this.onFieldChange("inputTelegramChannel", event.target.value)} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Status Dealer <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Select value={this.state.selectStatusDealer} onChange={(value) => this.onFieldChange("selectStatusDealer", value)}>
                            <Select.Option value="true">ACTIVE</Select.Option>
                            <Select.Option value="false">NONACTIVE</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Alamat</i>
                          <Input.TextArea value={this.state.inputAddress} onChange={(event) => this.onFieldChange("inputAddress", event.target.value)}></Input.TextArea>
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Kode Rekening Dealer (BCA) <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.inputBcaCompanyCode} onChange={(event) => this.onFieldChange("inputBcaCompanyCode", event.target.value)} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Nomor Rekening Dealer (BCA) <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.inputBcaCompanyAccount} onChange={(event) => this.onFieldChange("inputBcaCompanyAccount", event.target.value)} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Nomor NPWP <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.inputTaxAccountNumber} onChange={(event) => this.onFieldChange("inputTaxAccountNumber", event.target.value)} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Nama NPWP <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.inputTaxAccountName} onChange={(event) => this.onFieldChange("inputTaxAccountName", event.target.value)} />
                        </Form.Item>
                      </Col>

                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Persentasi Pajak <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.inputTaxPercentage} onChange={(event) => this.onFieldChange("inputTaxPercentage", event.target.value)} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <strong>Setting Whatsapp</strong>
                    <hr />
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Whatsapp Project ID</i>
                          <Space.Compact>
                            <Input value={this.state.inpustWhatsappProjectID} onChange={(event) => this.onFieldChange("inpustWhatsappProjectID", event.target.value)} />
                            <Button type="primary" onClick={this.showModalWhatappsTemplate}>
                              Add Template
                            </Button>
                          </Space.Compact>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <table style={{ fontSize: "83%", borderCollapse: "collapse", width: "100%" }}>
                          <tr>
                            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Trigger ID</th>
                            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Nama Template</th>
                            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Aktif</th>
                            <th style={{ border: "1px solid #ddd", padding: "8px" }}></th>
                          </tr>
                          {this.state.objWhatappsTemplate.map((r: any) => (
                            <tr id={r} key={r}>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>{r?.template_trigger_id}</td>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>{r?.template_name}</td>
                              <td style={{ border: "1px solid #ddd", padding: "8px" }}>{r?.template_status.toUpperCase()}</td>
                              <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                <Button onClick={() => this.deleteWhatappsTemplate(r)} type="primary" icon={<DeleteOutlined />} style={{ background: "#ff4d4f", borderColor: "#ff4d4f" }} />
                              </td>
                            </tr>
                          ))}
                        </table>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                    <Row>
                      {this.state.modeForm === "ADD" && (
                        <>
                          <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                            <Form.Item style={{ paddingRight: 10 }}>
                              <i className={`text-small-grey-nopadding`}>
                                Otomatis Buat Gudang <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <Select value={this.state.selectCreateWarehouseDefault} onChange={(value) => this.onFieldChange("selectCreateWarehouseDefault", value)}>
                                <Select.Option value="true">TRUE</Select.Option>
                                <Select.Option value="false">FALSE</Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                            <Form.Item style={{ paddingRight: 10 }}>
                              <i className={`text-small-grey-nopadding`}>
                                Otomatis Buat Supplier <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <Select value={this.state.selectCreateSupplierDefault} onChange={(value) => this.onFieldChange("selectCreateSupplierDefault", value)}>
                                <Select.Option value="true">TRUE</Select.Option>
                                <Select.Option value="false">FALSE</Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        </>
                      )}

                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Allow Edit Stock <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Select value={this.state.selectAllowEditStock} onChange={(value) => this.onFieldChange("selectAllowEditStock", value)}>
                            <Select.Option value="true">TRUE</Select.Option>
                            <Select.Option value="false">FALSE</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Allow Empty Engine Number <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Select value={this.state.selectAllowEmptyEngineNumber} onChange={(value) => this.onFieldChange("selectAllowEmptyEngineNumber", value)}>
                            <Select.Option value="true">TRUE</Select.Option>
                            <Select.Option value="false">FALSE</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Stop Closing <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Select value={this.state.selectSetStopClosing} onChange={(value) => this.onFieldChange("selectSetStopClosing", value)}>
                            <Select.Option value="true">TRUE</Select.Option>
                            <Select.Option value="false">FALSE</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Buat Tagihan Leasing <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Select value={this.state.selectAllowCreateBillLeasing} onChange={(value) => this.onFieldChange("selectAllowCreateBillLeasing", value)}>
                            <Select.Option value="true">TRUE</Select.Option>
                            <Select.Option value="false">FALSE</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Order BAST to AMH <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Select value={this.state.selectAllowSentOrderToAmh} onChange={(value) => this.onFieldChange("selectAllowSentOrderToAmh", value)}>
                            <Select.Option value="true">TRUE</Select.Option>
                            <Select.Option value="false">FALSE</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>
                            Order BAST Tracking <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Select value={this.state.selectAllowTrackOrder} onChange={(value) => this.onFieldChange("selectAllowTrackOrder", value)}>
                            <Select.Option value="true">TRUE</Select.Option>
                            <Select.Option value="false">FALSE</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      {this.state.modeForm === "EDIT" && (
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                          <Form.Item style={{ paddingRight: 10 }}>
                            <Checkbox checked={this.state.isEditAddionalDataChecked} onChange={(event) => this.setState({ isEditAddionalDataChecked: event.target.checked })}>
                              Edit Data Robobill & Main Dealer
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      )}
                    </Row>

                    <strong>Robobill Setting </strong>
                    <hr />
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Target Bussiness ID (IN)</i>
                          <Tooltip
                            title={
                              <>
                                <div>Dipakai saat pengiriman INVOICE ROBOBILL</div>
                                <div>digunakan pada:</div>
                                <ul style={{ paddingLeft: 20 }}>
                                  <li>Pembuatan Invoice IN Bayar Biaya PKB</li>
                                  <li>Pembuatan Invoice IN Bayar Biaya Jasa</li>
                                </ul>
                              </>
                            }
                          >
                            <InfoCircleOutlined style={{ marginLeft: 5, color: "#1890ff" }} />
                          </Tooltip>
                          <Input
                            value={this.state.inputTargetBussinessIdIn}
                            onChange={(event) => this.onFieldChange("inputTargetBussinessIdIn", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Target Bussiness Name (IN)</i>
                          <Tooltip
                            title={
                              <>
                                <div>Dipakai saat pengiriman INVOICE ROBOBILL</div>
                                <div>digunakan pada:</div>
                                <ul style={{ paddingLeft: 20 }}>
                                  <li>Pembuatan Invoice IN Bayar Biaya PKB</li>
                                  <li>Pembuatan Invoice IN Bayar Biaya Jasa</li>
                                </ul>
                              </>
                            }
                          >
                            <InfoCircleOutlined style={{ marginLeft: 5, color: "#1890ff" }} />
                          </Tooltip>
                          <Input
                            value={this.state.inputTargetBussinessNameIn}
                            onChange={(event) => this.onFieldChange("inputTargetBussinessNameIn", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Target Bussiness ID (OUT)</i>
                          <Tooltip
                            title={
                              <>
                                <div>Dipakai saat pengiriman INVOICE ROBOBILL</div>
                                <div>digunakan pada:</div>
                                <div>OUT dipakai di:</div>
                                <ul style={{ paddingLeft: 20 }}>
                                  <li>Pembuatan Invoice IN Bayar Biaya Process</li>
                                  <li>Pembuatan Invoice OUT Invoice Additional Cost pada Closing Order</li>
                                </ul>
                              </>
                            }
                          >
                            <InfoCircleOutlined style={{ marginLeft: 5, color: "#1890ff" }} />
                          </Tooltip>
                          <Input
                            value={this.state.inputTargetBussinessIdOut}
                            onChange={(event) => this.onFieldChange("inputTargetBussinessIdOut", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Target Bussiness Name (OUT)</i>
                          <Tooltip
                            title={
                              <>
                                <div>Dipakai saat pengiriman INVOICE ROBOBILL</div>
                                <div>digunakan pada:</div>
                                <div>OUT dipakai di:</div>
                                <ul style={{ paddingLeft: 20 }}>
                                  <li>Pembuatan Invoice IN Bayar Biaya Process</li>
                                  <li>Pembuatan Invoice OUT Invoice Additional Cost pada Closing Order</li>
                                </ul>
                              </>
                            }
                          >
                            <InfoCircleOutlined style={{ marginLeft: 5, color: "#1890ff" }} />
                          </Tooltip>
                          <Input
                            value={this.state.inputTargetBussinessNameOut}
                            onChange={(event) => this.onFieldChange("inputTargetBussinessNameOut", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <br />
                    <strong>Setting Bill BBN</strong>
                    <hr />
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>ID Target Bill Biaya Proses</i>
                          <Input
                            value={this.state.inputTargetProcessId}
                            onChange={(event) => this.onFieldChange("inputTargetProcessId", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Nama Target Biaya Proses</i>

                          <Input
                            value={this.state.inputTargetProcessName}
                            onChange={(event) => this.onFieldChange("inputTargetProcessName", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>ID Target Bill Biaya PKB</i>
                          <Input
                            value={this.state.inputTargetPkbId}
                            onChange={(event) => this.onFieldChange("inputTargetPkbId", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Nama Target Biaya PKB</i>

                          <Input
                            value={this.state.inputTargetPkbName}
                            onChange={(event) => this.onFieldChange("inputTargetPkbName", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>ID Target Bill Biaya Jasa</i>
                          <Input
                            value={this.state.inputTargetServiceId}
                            onChange={(event) => this.onFieldChange("inputTargetServiceId", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Nama Target Biaya Jasa</i>
                          <Input
                            value={this.state.inputTargetServiceName}
                            onChange={(event) => this.onFieldChange("inputTargetServiceName", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <strong>Main Dealer Setting</strong>
                    <hr />
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Kode Main Dealer</i>
                          <Input
                            value={this.state.inputMainDealerCode}
                            onChange={(event) => this.onFieldChange("inputMainDealerCode", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                        <Form.Item style={{ paddingRight: 10 }}>
                          <i className={`text-small-grey-nopadding`}>Kode Dealer di Main Dealer</i>
                          <Input
                            value={this.state.inputMainDealerCustomerCode}
                            onChange={(event) => this.onFieldChange("inputMainDealerCustomerCode", event.target.value)}
                            disabled={this.state.modeForm === "EDIT" && this.state.isEditAddionalDataChecked === false}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    {(this.state.modeForm === "ADD" || this.state.isEditAddionalDataChecked) && (
                      <Row>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                          <Form.Item style={{ paddingRight: 10 }}>
                            <i className="text-small-grey-nopadding">Maindealer Auth Username</i>
                            <Input value={this.state.inputMainDealerUserAuth} onChange={(event) => this.onFieldChange("inputMainDealerUserAuth", event.target.value)} />
                          </Form.Item>
                        </Col>

                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                          <Form.Item style={{ paddingRight: 10 }}>
                            <i className="text-small-grey-nopadding">Maindealer Auth Password</i>
                            <Input type="password" onChange={(event) => this.onFieldChange("inputMainDealerPassAuth", event.target.value)} />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                    <Button
                      type="primary"
                      icon={<SaveOutlined />}
                      onClick={() => {
                        this.onClicksave();
                      }}
                      loading={this.state.processing}
                    >
                      {" "}
                      Simpan Data
                    </Button>
                    &nbsp;&nbsp;&nbsp;
                    <Button
                      type="primary"
                      icon={<CloseCircleOutlined />}
                      onClick={() => {
                        this.onCloseFormWindow();
                      }}
                      style={{ background: "#ff4d4f", borderColor: "#ff4d4f" }}
                      loading={this.state.processing}
                    >
                      {" "}
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          )}

          <Modal title="Tambah Whatapps Template" visible={this.state.modalAddWhatappsTemplate} onOk={this.addWhatappsTemplate} onCancel={this.closeModalAddWhatappsTemplate}>
            <Form layout="horizontal" labelCol={{ span: 6 }}>
              <Form.Item label="Template Name">
                <Input value={this.state.inputWhatappsTemplateName} onChange={(event) => this.onFieldChange("inputWhatappsTemplateName", event.target.value)} />
              </Form.Item>
              <Form.Item label="Trigger">
                <Select value={this.state.inputWhatappsTriggerId} onChange={(value) => this.onFieldChange("inputWhatappsTriggerId", value)}>
                  <Select.Option value="BAST">BAST</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item label="Aktif">
                <Select value={this.state.inputWhatappsTemplateStatus} onChange={(value) => this.onFieldChange("inputWhatappsTemplateStatus", value)}>
                  <Select.Option value="true">TRUE</Select.Option>
                  <Select.Option value="false">FALSE</Select.Option>
                </Select>
              </Form.Item>
            </Form>
          </Modal>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(SettingDealer), 64);
